import {
  MelcoModelsUserProductListItem,
  useAPIAction,
  UserAccountApi,
} from "melco-shared-logic";
import { useNavigate } from "react-router-dom";

export const useLaunchApp = (product: MelcoModelsUserProductListItem) => {
  console.log(product);
  const navigate = useNavigate();

  return useAPIAction(
    UserAccountApi,
    async (api) => {
      const { code, app_startup_endpoint: appStartupEndpoint } = product;

      const response = await api.accountProductsStartUp({ productCode: code! });

      const { show_service_terms: showServiceTerms } = response;

      // console.log
      if (showServiceTerms === true) {
        navigate(`/dashboard/terms/${code}`);
        return;
      } else if (showServiceTerms === false) {
        console.log(appStartupEndpoint);
        // if (appStartupEndpoint) {
        console.log("33");

        window.location.reload();
        return;
        // }
      }

      // this should not happen, as showServiceTerms is expected to be
      // either true or false
      throw new Error();
    },
    { translationPrefix: "global" }
  );
};
